<template>
  <div>
    <v-alert
       prominent
        v-if="alert.message"
        v-model="alert"
        dismissible
        value=""
       :class="`${alert.type}`"
    >
   {{alert.message}}
    </v-alert>
  </div>
</template>

<script>
export default {
    name: 'Notify',
    computed: {
        alert () {
            return this.$store.getters['notify/getAlert']
        }
    },
    watch:{
        $route (to, from){
            console.log(to, from);
            // clear alert on location change
            this.$store.dispatch('notify/clear');
        }
    } 
};
</script>